export default __webpack_public_path__ + "static/media/verify2.53d08805.svg";